import React from "react";
import Select from "../components/form/Select";
import DateTimeInput from "../components/form/DateTimeInput";
import {ComponentOptions} from "./formatters";

export const priorityFilter = () => {
    return <Select
        isClearable={true}
        optionname="priority_value"
        objectValue={false}
        storeType="local"
        label={false}
    />;
}

export const booleanFilter = () => {
    return <Select
        isClearable={true}
        options={[{value: '1  ', label: 'Igen'},{value: '0  ', label: 'Nem'}]}
        objectValue={false}
        storeType="local"
        label={false}
        valueKey="value"
        labelKey="label"
    />;
}

export const activeFilter = () => {
    return <Select
        isClearable={true}
        options={[{value: '1  ', label: 'Aktív'},{value: '0  ', label: 'Inaktív'}]}
        objectValue={false}
        storeType="local"
        label={false}
        valueKey="value"
        labelKey="label"
    />;
}

export const optionFilter = (optionname) => {
    return <Select
        isClearable={true}
        objectValue={false}
        optionname={optionname}
        storeType="local"
        label={false}
    />;
}

export const componentFilter = ({component = null, labelfield = null, valuefield = null, props = {}}) => {
    if (Array.isArray(component)) {
        return <Select
            storeType="local"
            options={component.length ? component : ComponentOptions}
            label={false}
            objectValue={false}
            isClearable={true}
            valueKey={valuefield || "key"}
            labelKey={labelfield || "label"}
            {...props}
        />;
    } else {
        return <Select
            storeType="local"
            label={false}
            component={component}
            labelKey={labelfield}
            valueKey={valuefield}
            objectValue={false}
            isClearable={true}
            {...props}
        />;
    }
}

export const dateFilter = () => {
    return <DateTimeInput label={false} isClearable={true}/>
}

export const localOptionFilter = (options, key = "key", label = "label") => {
    return <Select
        storeType="local"
        options={options}
        label={false}
        objectValue={false}
        isClearable={true}
        valueKey={key}
        labelKey={label}
    />
}